var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"d-avatar",class:{ 'avatar-border': _vm.border }},[_c('v-avatar',{attrs:{"size":_vm.size}},[(_vm.blobAvatar)?_c('img',{attrs:{"src":_vm.blobAvatar}}):_c('img',{attrs:{"src":require("@/img/user-light.png")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }